import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TableOptions } from "../../../../shared-kernel/components/Table";
import {
  createAdapterToFieldPaymentMethodEndpoint,
  createAdapterToPaymentMethod,
  createAdapterToPaymentMethodEndpoint
} from "../adapters/paymentMethod.adapter";
import { EndpointPaymentMethodFiltered, PaymentMethod, PaymentMethodEndpoint } from "../domain/PaymentMethod.model";
import { appConfig } from "../../../../config";
import { EndpointPaymentMethod } from "../domain/PaymentMethod.model";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";


const BASE_PAYMENT_METHOD_URL = '/estimaciones/formatospagos'
const BASE_PAYMENT_METHOD_MUTATION_URL = '/estimaciones/formatopago'
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/estimaciones/formatospagos/export`;

export const paymentMethodApi = createApi({
  reducerPath: "paymentMethodApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["PaymentMethods", "PaymentMethod"],
  endpoints: (builder) => ({
    getPaymentMethod: builder.query<PaymentMethod, number | undefined>({
      query: (id) => `${BASE_PAYMENT_METHOD_MUTATION_URL}/${id}`,
      transformResponse: (response: EndpointPaymentMethod) => {
        return createAdapterToPaymentMethod(response.Content)
      },
      providesTags: (_res, _err, id) => [{type: "PaymentMethod", id: id?.toString()}],
    }),
    getPaymentMethods: builder.query<any, TableOptions<PaymentMethod>|undefined>({
      query: (params: TableOptions<PaymentMethod>) => {
        const { page, pageSize, order, search, filters } = params || {};
        const adaptersFilter = filters?.map( f => createAdapterToFilterBackend(f,createAdapterToFieldPaymentMethodEndpoint))
        const serializedFilters = adaptersFilter ? JSON.stringify(adaptersFilter) : undefined;
        const serializedOrder = order ? JSON.stringify({field:createAdapterToFieldPaymentMethodEndpoint(order.field), order:order.order}) : undefined;
        return {
          url:`${BASE_PAYMENT_METHOD_URL}/filtros`,
          params: {
            page:page? page - 1: 0,
            pageSize,
            order: serializedOrder,
            search,
            filters:serializedFilters
          },
        }
      },
      providesTags: ["PaymentMethods"],
      transformResponse: (response: EndpointPaymentMethodFiltered, _meta, params: TableOptions<PaymentMethod>) => {
        const page = params?.page ?? 1;
        const endpointResponse = response?.rows?.map((paymentMethod: PaymentMethodEndpoint) =>
            createAdapterToPaymentMethod(paymentMethod)
        );
        return {
          data: endpointResponse,
          page,
          total: response.total,
        };
      },
    }),
    createPaymentMethod: builder.mutation<any, PaymentMethod>({
      query: (data) => ({
        url: `${BASE_PAYMENT_METHOD_MUTATION_URL}`,
        method: "POST",
        body: {
          "Content": createAdapterToPaymentMethodEndpoint(data)
        },
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    updatePaymentMethod: builder.mutation<any, PaymentMethod>({
      query: (data: PaymentMethod) => ({
        url: `${BASE_PAYMENT_METHOD_MUTATION_URL}`,
        method: "PUT",
        body: {
          "Content": createAdapterToPaymentMethodEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: PaymentMethod) => ["PaymentMethods", {type: "PaymentMethod", id: data?.id?.toString()}],
    }),
    deletePaymentMethod: builder.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_PAYMENT_METHOD_MUTATION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
  }),
});

export const {
  useGetPaymentMethodQuery,
  useGetPaymentMethodsQuery,
  useCreatePaymentMethodMutation,
  useUpdatePaymentMethodMutation,
  useDeletePaymentMethodMutation
} = paymentMethodApi;
